module.exports = __webpack_public_path__ + "img/17-4.436906a8.png";